import { useEffect, useState } from "react";
import { getFeatureFlags } from "../../shared/featureFlagService";

/**
 * Custom hook to manage the side navigation feature flag
 * @returns {boolean} isSideNavEnabled - Whether the side navigation is enabled
 */
export const useSideNavFeatureFlag = () => {
    const [isSideNavEnabled, setIsSideNavEnabled] = useState(true);

    useEffect(() => {
        const fetchFeatureFlags = async () => {
            return await getFeatureFlags("one-web-domain");
        };

        fetchFeatureFlags()
            .then(flags => {
                if (
                    typeof flags === "object" &&
                    Object.prototype.hasOwnProperty.call(flags, "shouldUseSideNav")
                ) {
                    setIsSideNavEnabled(flags.shouldUseSideNav);
                }
            })
            .catch(error => {
                // eslint-disable-next-line no-console
                console.error("Failed to fetch feature flags:", error);
            });
    }, []);

    return isSideNavEnabled;
};
